import { useNavigate } from "react-router";
import { PeerReviewListItemStatus } from "./peerReviewsApiSlice";

export function PeerReviewActionButton(props: {
	action: PeerReviewListItemStatus;
	reviewId: number;
	disabled?: boolean;
	className?: string;
}) {
	const navigate = useNavigate();

	const buttonText = ((action) => {
		switch (action) {
			case PeerReviewListItemStatus.NotStarted:
				return "Start Review";
			case PeerReviewListItemStatus.InProgress:
				return "Continue Review";
			case PeerReviewListItemStatus.Complete:
				return "Open Review";
			default:
				return null;
		}
	})(props.action);

	const className = `btn ${props.className ?? "btn-action"}`;

	return (
		<button
			id={`review-${props.reviewId}`}
			className={className}
			onClick={() => navigate(`/reviews/${props.reviewId}`)}
			disabled={props.disabled}>
			{buttonText}
		</button>
	);
}
